import React from "react";
import { getSearchResult } from "../actions/searchAction";
import { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { bulkMessageListColumns } from "../config/column_fields";
import moment from 'moment';

class BulkMessageList extends Component {
    constructor() {
        super();
        this.state = {
            messageListColumns: [],
            messageList: [],
            isAdmin: false
        };
    }

    componentDidMount() {

    }

    handleApproveClick = (row) => {
        console.log("row.original", row);
        let { messageId = '' } = row || {};
        this.props.approveMessage(messageId);
        let { messageList } = this.state;
        messageList = messageList.map(row => {
            if(row.messageId === messageId) row.isApproved = 1;
            return row;
        })
        this.setState({ messageList: messageList })
    }

    handleDownloadAttachmentClick = (row) => {
        console.log("handleDownloadAttachmentClick", row);
        let { filePath = '' } = row || {};
        this.props.downloadAttachmentFile(filePath);
    }

    handleCancelClick = (row) => {
        console.log("row.original", row);
        let { messageId = '' } = row || {};
        this.props.cancelMessage(messageId);
        let { messageList } = this.state;
        messageList = messageList.map(row => {
            if(row.messageId === messageId) row.isCancelled = 1;
            return row;
        })
        this.setState({ messageList: messageList })
    }

    componentWillMount() {
        this.props.fetchBulkMessageList();
        console.log("userObj", this.props.userObj);
        if(this.props.userObj && this.props.userObj.email && [ 'shubham.arora@zunroof.com', 'prateek.suraj@zunroof.com' ].includes(this.props.userObj.email)) {
            this.setState({ isAdmin: true });
        }
        let messageListColumns = bulkMessageListColumns.map(row => {
            if(row.accessor === 'isApproved') {
                row.Cell = (row) => {
                    if(row.original.isCancelled) return "Canceled";
                    else if(row.value == 0) {
                        if(!this.state.isAdmin) return "Approval Pending";
                        else return <button className="btn btn-sm btn-success" onClick={() => this.handleApproveClick(row.original)}>Approve</button>
                    }
                    else return "Yes";
                }
            }
            else if(row.accessor === 'downloadAttachment') {
                row.Cell = (row) => {
                    if(row.original.hasAttachment && row.original.filePath) {
                        return <button className="btn btn-sm btn-success" onClick={() => this.handleDownloadAttachmentClick(row.original)}>Download</button>
                    }
                    else return "";
                }
            }
            else if(row.accessor === 'isCancelled') {
                row.Cell = (row) => {
                    if(row.original.messageSentAt) return "";
                    else if(row.original.isCancelled) return "Canceled";
                    else if(row.original.scheduledTime && moment(row.original.scheduledTime).isAfter()) {
                        return <button className="btn btn-sm btn-success" onClick={() => this.handleCancelClick(row.original)}>Cancel</button>
                    }
                    else return "";
                }
            }
            return row;
        })
        this.setState({ messageListColumns: messageListColumns })
    }

    componentWillReceiveProps({ bulkMessageList }) {
        this.setState({ messageList: bulkMessageList })
    }

    render() {
        return (
            <div className="procurementAddVendor">
                <ReactTable
                    filterable={true}
                    showPagination={true}
                    sortable={true}
                    data={this.state.messageList}
                    columns={this.state.messageListColumns}
                    defaultSorted={[{ id: "id", desc: true }]}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id])
                            .toLowerCase()
                            .indexOf(filter.value.toLowerCase()) > -1
                    }
                    defaultPageSize={10}
                />
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getSearchResult }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkMessageList);
